import React from 'react'
import { states } from './states'
import { MenuItem, TextField, Typography } from '@mui/material'
import { EXP_REGEX } from '../constants'

const BillingInfo = ({
  billingInfo,
  handleBillingFieldChange,
  Row,
  hideTitle = false,
}) => {
  const validEXP = EXP_REGEX.test(billingInfo.exp)

  return (
    <>
      {!hideTitle && (
        <Typography variant='h6' sx={{ textAlign: 'left', marginTop: '16px' }}>
          Billing Information
        </Typography>
      )}

      <Typography sx={{ color: 'red', fontSize: '14px' }}>
        {billingInfo.exp && !validEXP && (
          <i>Please enter an expiration date in the form MM/YY</i>
        )}
        &nbsp;
      </Typography>

      <Row>
        <TextField
          margin='dense'
          sx={{ flexGrow: 1 }}
          value={billingInfo.cardNumber}
          onChange={(e) => {
            handleBillingFieldChange({
              ...billingInfo,
              cardNumber: e.target.value,
            })
          }}
          required
          label='Credit Card Number'
        />
        <TextField
          required
          label={'Exp'}
          margin='dense'
          value={billingInfo.exp}
          sx={{ maxWidth: '100px', ml: 1, mr: 1 }}
          placeholder='MM/YY'
          onChange={(e) => {
            handleBillingFieldChange({
              ...billingInfo,
              exp: e.target.value,
            })
          }}
        ></TextField>
      </Row>
      <TextField
        margin='dense'
        fullWidth
        value={billingInfo.cardName}
        onChange={(e) => {
          handleBillingFieldChange({
            ...billingInfo,
            cardName: e.target.value,
          })
        }}
        required
        label='Name On Card'
      />
      <TextField
        margin='dense'
        fullWidth
        value={billingInfo.streetAddress}
        onChange={(e) => {
          handleBillingFieldChange({
            ...billingInfo,
            streetAddress: e.target.value,
          })
        }}
        required
        label='Billing Address'
      />
      <Row>
        <TextField
          margin='dense'
          value={billingInfo.city}
          onChange={(e) => {
            handleBillingFieldChange({
              ...billingInfo,
              city: e.target.value,
            })
          }}
          required
          label='City'
          sx={{ marginRight: '8px', flexGrow: 1 }}
        />

        <TextField
          required
          margin='dense'
          label={'State'}
          value={billingInfo.state}
          onChange={(e) =>
            handleBillingFieldChange({
              ...billingInfo,
              state: e.target.value,
            })
          }
          select
          sx={{ marginRight: '8px', width: '100px' }}
        >
          <MenuItem value={''} />
          {states.map((s) => (
            <MenuItem key={s} value={s}>
              {s}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          sx={{ marginRight: '8px', flexGrow: 1, width: '200px' }}
          margin='dense'
          value={billingInfo.postal}
          onChange={(e) => {
            // clearErrors()
            handleBillingFieldChange({
              ...billingInfo,
              postal: e.target.value,
            })
          }}
          required
          label='Postal Code'
        />
      </Row>
    </>
  )
}

export default BillingInfo
